const PRINT_STYLE = `
@media print {
  body * { visibility: hidden !important; }
  #mission-print-sheet, #mission-print-sheet * { visibility: visible !important; }
  #mission-print-sheet {
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    background: #fff !important;
  }
  @page { size: A4 portrait; margin: 12mm; }
}
#mission-print-sheet {
  position: fixed;
  left: -9999px;
  top: 0;
  width: 210mm;
  min-height: 297mm;
  background: #fff;
  color: #111;
  direction: rtl;
  font-family: Tahoma, Arial, sans-serif;
  box-sizing: border-box;
}
.mp-brand-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  background: linear-gradient(135deg, #1B3068 0%, #233A7A 45%, #29AAE1 100%);
  color: #fff;
}
.mp-brand-org { font-size: 16px; font-weight: 800; margin: 0 0 3px; text-align: center; flex: 1; }
.mp-brand-sub { font-size: 11px; margin: 0; opacity: 0.9; text-align: center; }
.mp-body { padding: 12mm; }
.mp-title { font-size: 17px; font-weight: 800; margin: 0 0 14px; text-align: center; color: #0f172a; border-bottom: 2px solid #1B3068; padding-bottom: 10px; }
.mp-meta { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 16px; font-size: 12px; }
.mp-meta-box { border: 1px solid #B7C9EC; border-radius: 8px; padding: 8px 10px; background: #EDF3FC; }
.mp-meta-label { font-size: 10px; color: #64748b; margin-bottom: 4px; }
.mp-meta-value { font-weight: 700; color: #0f172a; }
.mp-section { margin-bottom: 18px; }
.mp-section-title { font-size: 12px; font-weight: 700; color: #334155; margin-bottom: 8px; }
.mp-text-box { border: 1px solid #cbd5e1; border-radius: 8px; padding: 12px; min-height: 80px; font-size: 12px; line-height: 1.7; white-space: pre-wrap; }
.mp-signatures { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; margin-top: 24px; page-break-inside: avoid; }
.mp-sign-box { border: 1px solid #64748b; border-radius: 8px; padding: 10px; min-height: 88px; display: flex; flex-direction: column; justify-content: space-between; }
.mp-sign-label { font-size: 11px; font-weight: 700; color: #0f172a; text-align: center; }
.mp-sign-line { border-bottom: 1px dashed #94a3b8; height: 46px; margin-top: 8px; }
.mp-sign-img { height: 46px; margin-top: 8px; display: flex; align-items: center; justify-content: center; }
.mp-sign-img img { max-height: 44px; max-width: 100%; object-fit: contain; }
.mp-footnote { font-size: 9px; color: #94a3b8; text-align: center; margin-top: 12px; padding-top: 8px; border-top: 1px solid #e2e8f0; }
`;

export default function MissionPrintForm({
  title,
  missionText,
  employeeName,
  dateLabel,
  companyName,
  distanceKm,
  expertSignatureUrl,
  approverName,
  approverSignatureUrl,
  approvalStatus,
}) {
  const distanceLabel = distanceKm != null && distanceKm > 0
    ? `${Number(distanceKm).toFixed(2)} کیلومتر`
    : null;
  const logoSrc = `${window.location.origin}/pejvak-mark.svg`;

  return (
    <>
      <style>{PRINT_STYLE}</style>
      <div id="mission-print-sheet" aria-hidden="true">
        <div className="mp-brand-bar">
          <img src={logoSrc} alt="" style={{ width: 34, height: 34, borderRadius: 8 }} onError={(e) => { e.currentTarget.style.display = 'none'; }} />
          <div style={{ flex: 1 }}>
            <p className="mp-brand-org">پژواک رایانه نقش جهان</p>
            <p className="mp-brand-sub">فرم گزارش و تایید ماموریت</p>
          </div>
        </div>

        <div className="mp-body">
          <h1 className="mp-title">گزارش اجرای ماموریت</h1>

          <div className="mp-meta">
            <div className="mp-meta-box">
              <div className="mp-meta-label">تاریخ</div>
              <div className="mp-meta-value">{dateLabel || '—'}</div>
            </div>
            <div className="mp-meta-box">
              <div className="mp-meta-label">مسئول ماموریت</div>
              <div className="mp-meta-value">{employeeName || '—'}</div>
            </div>
            {companyName && (
              <div className="mp-meta-box" style={{ gridColumn: '1 / -1' }}>
                <div className="mp-meta-label">شرکت</div>
                <div className="mp-meta-value">{companyName}</div>
              </div>
            )}
          </div>

          <div className="mp-section">
            <div className="mp-section-title">عنوان ماموریت</div>
            <div className="mp-text-box">{title || '—'}</div>
          </div>

          <div className="mp-section">
            <div className="mp-section-title">گزارش اجرا</div>
            <div className="mp-text-box">{missionText || '—'}</div>
          </div>

          {distanceLabel && (
            <div className="mp-meta-box" style={{ marginBottom: 16 }}>
              <div className="mp-meta-label">مسافت طی‌شده (برآورد)</div>
              <div className="mp-meta-value">{distanceLabel}</div>
            </div>
          )}

          {approvalStatus && (
            <div className="mp-meta-box" style={{ marginBottom: 16 }}>
              <div className="mp-meta-label">وضعیت تایید</div>
              <div className="mp-meta-value">{approvalStatus}</div>
            </div>
          )}

          <div className="mp-signatures">
            <div className="mp-sign-box">
              <div className="mp-sign-label">امضای کارشناس</div>
              {expertSignatureUrl ? (
                <div className="mp-sign-img">
                  <img src={expertSignatureUrl} alt="" />
                </div>
              ) : (
                <div className="mp-sign-line" />
              )}
            </div>
            <div className="mp-sign-box">
              <div className="mp-sign-label">
                {approverName ? `امضای تاییدکننده (${approverName})` : 'امضای تاییدکننده شرکت'}
              </div>
              {approverSignatureUrl ? (
                <div className="mp-sign-img">
                  <img src={approverSignatureUrl} alt="" />
                </div>
              ) : (
                <div className="mp-sign-line" />
              )}
            </div>
          </div>

          <p className="mp-footnote">crm.pejvakrayane.com — صادرشده از سامانه CRM پژواک رایانه</p>
        </div>
      </div>
    </>
  );
}
